export default {
    baseStyle: (props) => ({
        trigger: {
            ml: 'auto',
            color: 'webTypo.textPrimary',
            textStyle: {base: 'bodyXsLink', lg: 'bodyXsLink'},
            letterSpacing: '0px',
            textDecor: 'underline',
            height: 'auto',
            marginBottom: 2
        },
        content: {
            maxW: props?.drawerMaxSize
        },
        closeButton: {
            position: 'absolute',
            top: '22px',
            right: 4
        },
        body: {
            padding: 0
        },
        bodyContent: {
            padding: '16px 0 16px 16px'
        },
        drawerTitle: {
            textStyle: 'webH3',
            padding: 4,
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'webTheme.strokeTertiary'
        },
        unitButton: {
            display: 'block',
            textStyle: 'labelXs',
            padding: '11px 8px'
        },
        tableContainer: {
            overflowX: 'auto',
            '&::-webkit-scrollbar': {
                height: '11px'
            },
            '&::-webkit-scrollbar-button': {
                display: 'none',
                width: 0,
                height: 0
            },
            '&::-webkit-scrollbar-track': {
                background: 'transparent',
                border: '1px solid',
                borderColor: 'webTheme.strokeTertiary',
                borderRadius: '100px'
            },
            '&::-webkit-scrollbar-thumb': {
                background: 'webTheme.strokeSecondary',
                borderRadius: '100px'
            },
            scrollbarColor: 'webTheme.strokeTertiary transparent'
        },
        tableGrid: {
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid',
            borderLeftColor: 'webTheme.strokeSecondary'
        },
        tableHeaderCell: {
            textStyle: 'bodyXsBold',
            backgroundColor: 'webTheme.backgroundSecondaryBrand',
            minWidth: '97px',
            borderRightWidth: '1px',
            borderRightStyle: 'solid',
            borderRightColor: 'webTheme.strokeSecondary',
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'webTheme.strokeSecondary',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'webTheme.strokeSecondary',
            padding: '10px 8px 8px',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            _first: {
                textAlign: 'left'
            }
        },
        tableDataCell: {
            textStyle: 'bodyXsRegular',
            backgroundColor: 'webTheme.backgroundNotification',
            borderRightWidth: '1px',
            borderRightStyle: 'solid',
            borderRightColor: 'webTheme.strokeSecondary',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'webTheme.strokeSecondary',
            padding: '10px 8px 8px',
            whiteSpace: 'nowrap',
            textAlign: 'left'
        },
        tableValueCell: {
            textStyle: 'bodyXsRegular',
            minWidth: '97px',
            borderRightWidth: '1px',
            borderRightStyle: 'solid',
            borderRightColor: 'webTheme.strokeSecondary',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: 'webTheme.strokeSecondary',
            padding: '10px 8px 8px',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        },
        bodyMeasurements: {
            textStyle: 'webH4',
            marginBottom: 1
        },
        bodyMeasurementsText: {
            textStyle: 'bodySmRegular'
        },
        measurementsHeading: {
            textStyle: 'webH4',
            marginBottom: 1
        },
        measurementsDescription: {
            textStyle: 'bodySmRegular'
        },
        noteText: {
            textStyle: 'bodyXsRegular'
        },
        tableDescription: {
            textStyle: 'bodySmRegular',
            marginBottom: 4
        }
    }),
    variants: {
        sizeGuidePage: (props) => ({
            drawerTitle: {
                padding: '0 0 24px 0',
                borderBottom: 'none'
            },
            bodyContent: {
                padding: 0
            },
            menuTrigger: {
                textStyle: 'bodySmRegular'
            },
            menuItem: {
                textStyle: 'bodySmRegular'
            }
        })
    }
}
